import { useContext } from "react";
import DepositModalContext from "../store/DepositModalContext";
import DisconnectModalBox from "./DisconnectModalBox";
const DisconnectModal = () => {
  const { activeModalDis, hideModalDis, showModalDis } =
    useContext(DepositModalContext);
  return (
    <>
      {activeModalDis && (
        <DisconnectModalBox handleClose={hideModalDis} handleOpen={showModalDis} />
      )}
    </>
  );
};
export default DisconnectModal;
